import React, { Component } from 'react';
import { Box, InputBase, Typography } from '@mui/material';
import { ALERT_SEVERITY } from './AlertDisplay2';

export class PostalCodeInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isActive: props.isActive,
            zip: '',
            minOrderAmount: '',
            deliveryFee: '',
        };

        this.zipInputRef = React.createRef();
    }

    onAdd = () => {
        const { disabled, onAdd, showAlert } = this.props;
        const { zip } = this.state;

        if (disabled) {
            showAlert?.('Die Daten können nicht bearbeitet werden.', ALERT_SEVERITY.WARNING);
            return;
        }

        if (onAdd) {
            if (zip.length === 5) {
                onAdd(zip);
                this.setState({ zip: '' });
            }
        }
    };

    render() {
        const { isPickupMode, showAlert, style } = this.props;

        return (
            <Box
                sx={{
                    border: '1px solid #EAEAEA',
                    borderRadius: '6px',
                    minHeight: 52,
                    display: 'flex',
                    alignItems: 'stretch',
                    overflow: 'hidden',
                    ...style,
                }}
            >
                <Box
                    sx={{
                        backgroundColor: '#F3F3F3',
                        display: 'flex',
                        flexDirection: 'row',
                        px: 1.25,
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRight: '1px solid #EAEAEA',
                        minWidth: 0,
                    }}
                >
                    <Box
                        component="img"
                        src={require('../assets/icons/pin.png')}
                        alt=""
                        sx={{ width: 18, height: 18, objectFit: 'contain', flexShrink: 0 }}
                    />
                    <Typography
                        sx={{
                            width: '80%',
                            fontSize: 14,
                            color: '#353535',
                            pl: 1,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        Standort:
                    </Typography>
                </Box>

                <InputBase
                    inputRef={this.zipInputRef}
                    value={this.state.zip}
                    placeholder="PLZ"
                    onFocus={() => {
                        if (isPickupMode) {
                            showAlert?.(
                                'Standortbeschränkungen sind bei Abholung nicht erlaubt.',
                                ALERT_SEVERITY.WARNING
                            );
                            this.zipInputRef.current?.blur();
                            return;
                        }
                    }}
                    onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, '');
                        this.setState({ zip: value });
                    }}
                    inputProps={{
                        maxLength: 5,
                        inputMode: 'numeric',
                    }}
                    sx={{
                        flex: 2,
                        textAlign: 'center',
                        borderRight: '1px solid #EAEAEA',
                        px: 1,
                        '& input': {
                            textAlign: 'center',
                            fontSize: 14,
                        },
                    }}
                />

                <Box
                    onClick={this.onAdd}
                    sx={{
                        flex: 1,
                        backgroundColor: '#FF952F',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                        px: 1,
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 'bold',
                            fontSize: 14,
                            color: '#ffffff',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        Hinzufügen
                    </Typography>
                </Box>
            </Box>
        );
    }
}

export default PostalCodeInput;